module.exports = __webpack_public_path__ + "img/xhs97.9df105fa.jpg";